let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hCGN9")).then(() => parcelRequire('cwxjA'));